function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2696 17.0005C17.8666 17.0005 17.54 16.6728 17.54 16.2684V14.2086C17.54 14.1168 17.4655 14.042 17.3749 14.042H2.62507C2.53365 14.042 2.4591 14.1168 2.4591 14.2086V16.2684C2.4591 16.6728 2.13249 17.0005 1.72955 17.0005C1.32661 17.0005 1 16.6728 1 16.2684V4.73253C1 4.32822 1.32661 4.00049 1.72955 4.00049C2.13249 4.00049 2.4591 4.32822 2.4591 4.73253V12.4114C2.4591 12.5031 2.53365 12.5779 2.62507 12.5779H18.834C18.9254 12.5779 18.9991 12.6527 18.9991 12.7445V16.2684C18.9991 16.6728 18.6725 17.0005 18.2696 17.0005Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7.51245C6.10398 7.51245 7 8.41061 7 9.5187C7 10.6268 6.10398 11.5261 5 11.5261C3.89602 11.5261 3 10.628 3 9.5187C3 8.40942 3.89483 7.51245 5 7.51245Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9.06128V11.3196C19 11.4333 18.9127 11.5261 18.8058 11.5261H8.19424C8.08643 11.5261 8 11.4333 8 11.3196V7.71896C8 7.60529 8.08732 7.51245 8.19424 7.51245H17.5432C18.3478 7.51245 19 8.20587 19 9.06128Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHotel);
export default __webpack_public_path__ + "static/media/icon-hotel.bd1064de2b4b1fce35d8330a0919a52d.svg";
export { ForwardRef as ReactComponent };